import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'

export const HOW_MUSIC_BOOSTS_ARTICLE_TITLE: string =
  'How Music Boosts Productivity by 90% in Business'
export const HOW_MUSIC_BOOSTS_ARTICLE_TITLE_ES: string =
  'Cómo la música aumenta la productividad empresarial en un 90%'
export const HOW_MUSIC_BOOSTS_ARTICLE_TITLE_FR: string =
  'Comment la musique augmente la productivité des entreprises de 90 %'
export const HOW_MUSIC_BOOSTS_ARTICLE_TITLE_KO: string =
  '음악이 업무 생산성을 90% 향상시키는 방법'

export const HOW_MUSIC_BOOSTS_TITLE_HTML: JSX.Element = (
  <>How Music Boosts Productivity by 90% in Business</>
)
export const HOW_MUSIC_BOOSTS_TITLE_HTML_ES: JSX.Element = (
  <>Cómo la música aumenta la productividad empresarial en un 90%</>
)
export const HOW_MUSIC_BOOSTS_TITLE_HTML_FR: JSX.Element = (
  <>Comment la musique augmente la productivité des entreprises de 90&nbsp;%</>
)
export const HOW_MUSIC_BOOSTS_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      음악이
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      업무
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      생산성을
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      90%
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      향상시킬
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      수
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      있는
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      방법
    </span>
  </>
)

export const HOW_MUSIC_BOOSTS_PAGE_ID: string =
  'D314B637-79F1-491C-8575-562630917343'

export const HOW_MUSIC_BOOSTS_ARTICLE_ROUTE: string =
  '/articles/how-music-boosts-productivity'
export const HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_ES: string =
  '/articles/how-music-boosts-productivity'
export const HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_FR: string =
  '/articles/how-music-boosts-productivity'
export const HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_KO: string =
  '/articles/how-music-boosts-productivity'

export const HOW_MUSIC_BOOSTS_ARTICLE_URL: string =
  HOST + HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_ES
export const HOW_MUSIC_BOOSTS_ARTICLE_URL_ES: string =
  HOST + '/es' + HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_ES
export const HOW_MUSIC_BOOSTS_ARTICLE_URL_FR: string =
  HOST + '/fr' + HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_FR
export const HOW_MUSIC_BOOSTS_ARTICLE_URL_KO: string =
  HOST + '/ko' + HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'workplace productivity, background music, neuroscience, business background music, ambient music, music licensing, music copyright, stress reduction, workplace music, employee satisfaction, music psychology, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'productividad laboral, música de fondo, neurociencia, música de fondo en el lugar de trabajo, música ambiental, licencias musicales, derechos de autor musicales, reducción del estrés, música en el trabajo, satisfacción de los empleados, psicología de la música, practical stream'
export const ARTICLE_KEYWORDS_FR =
  "productivité au travail, musique d'ambiance, neurosciences, musique d'ambiance en entreprise, musique ambiante, licences musicales, droits d'auteur musicaux, réduction du stress, musique au travail, satisfaction des employés, psychologie de la musique, practical stream"
export const ARTICLE_KEYWORDS_KO =
  '직장 생산성, 배경 음악, 신경과학, 비즈니스 배경 음악, 앰비언트 음악, 음악 라이선싱, 음악 저작권, 스트레스 감소, 직장 음악, 직원 만족도, 음악 심리학, practical stream'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '5C2725D3-B35E-45F6-A74B-60E91BB76126.avif?g=5'
  : HOST + '/images/5C2725D3-B35E-45F6-A74B-60E91BB76126.avif?g=5'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '5C2725D3-B35E-45F6-A74B-60E91BB76126.jpg?g=5'
  : HOST + '/images/5C2725D3-B35E-45F6-A74B-60E91BB76126.jpg?g=5'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '4DCDC74F-D781-41DB-88F5-C88FE72F17AD.jpg?g=1'
  : HOST + '/images/4DCDC74F-D781-41DB-88F5-C88FE72F17AD.jpg?g=1'

export const HOW_MUSIC_BOOSTS_JSON_LD_IMAGE_1200_X_1200: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '4DCDC74F-D781-41DB-88F5-C88FE72F17AD.png'
  : HOST + '/images/4DCDC74F-D781-41DB-88F5-C88FE72F17AD.png'

export const ARTICLE_SUMMARY: string =
  'Strategic workplace music doesn’t just make offices more pleasant — it fundamentally rewires your brain chemistry for enhanced focus, dramatically reduces stress hormones by up to 61%, and can boost work performance by an astonishing 90%. The science is conclusive, and the evidence is overwhelming: background music is a crucial element of productive workplaces.'
export const ARTICLE_SUMMARY_ES: string =
  'La música estratégica en el lugar de trabajo no solo hace que las oficinas sean más agradables, sino que modifica fundamentalmente la química cerebral para mejorar la concentración, reduce drásticamente las hormonas del estrés hasta en un 61% y puede aumentar el rendimiento laboral en un sorprendente 90%. La ciencia lo confirma y la evidencia es abrumadora: la música de fondo es un elemento crucial para los entornos de trabajo productivos.'
export const ARTICLE_SUMMARY_FR: string =
  "Une musique d'ambiance judicieusement choisie au travail ne se contente pas de rendre les bureaux plus agréables ; elle modifie en profondeur la chimie du cerveau pour améliorer la concentration, réduit considérablement les hormones du stress (jusqu'à 61 %) et peut augmenter la productivité de manière impressionnante, jusqu'à 90 %. La science le confirme, et les preuves sont accablantes : la musique d'ambiance est un élément crucial pour des environnements de travail productifs."
export const ARTICLE_SUMMARY_KO: string =
  '직장에서 신중하게 선택된 배경 음악은 단순히 사무실 분위기를 좋게 만드는 것 이상의 효과를 가져옵니다. 배경 음악은 뇌 화학 작용에 깊은 영향을 미쳐 집중력을 향상시키고, 스트레스 호르몬 수치를 현저히 감소시키며(최대 61%까지), 생산성을 최대 90%까지 크게 높일 수 있습니다. 과학적으로도 이러한 사실이 입증되었으며, 관련 증거는 매우 많습니다. 배경 음악은 생산적인 업무 환경을 조성하는 데 있어 필수적인 요소입니다.'

export const HOW_MUSIC_BOOSTS_ARTICLE_PUBLISHED_STR: string = '2025-12-10'
export const HOW_MUSIC_BOOSTS_ARTICLE_CREATED_STR: string = '2025-12-10'
export const HOW_MUSIC_BOOSTS_ARTICLE_PUBLISHED: Date = new Date(
  HOW_MUSIC_BOOSTS_ARTICLE_PUBLISHED_STR
)
export const HOW_MUSIC_BOOSTS_ARTICLE_CREATED: Date = new Date(
  HOW_MUSIC_BOOSTS_ARTICLE_CREATED_STR
)
